import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home, ChevronRight } from "lucide-react";
import type { BreadcrumbProps } from "./types";

const Breadcrumb: React.FC<BreadcrumbProps> = ({ onBack }) => {
  return (
    <nav className="mb-6" aria-label="Breadcrumb">
      <div className="flex items-center gap-2 text-sm">
        {/* Back Button */}
        <button
          onClick={onBack}
          className="flex items-center gap-1.5 px-2 py-1 sm:px-3 sm:py-1.5 text-section-muted hover:text-section-text hover:bg-section-surface rounded-lg transition-colors"
          aria-label="Go back"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="font-medium hidden sm:inline">Back</span>
        </button>

        <div className="flex items-center gap-2 text-section-muted flex-1 min-w-0 overflow-x-auto whitespace-nowrap">
          <span className="text-section-border hidden sm:inline">|</span>

          {/* Home Link */}
          <Link
            to="/"
            className="flex items-center gap-1.5 px-2 py-1 text-section-muted hover:text-section-text hover:bg-section-surface rounded transition-colors"
            aria-label="Home"
          >
            <Home className="w-4 h-4" />
            <span>Home</span>
          </Link>

          {/* Hide this chevron on very small screens to save space */}
          <ChevronRight className="w-4 h-4 text-section-muted hidden sm:block" />

          {/* Products Link */}
          <Link
            to="/products"
            className="px-2 py-1 text-section-muted hover:text-section-text hover:bg-section-surface rounded transition-colors hidden sm:inline"
          >
            Products
          </Link>

          <ChevronRight className="w-4 h-4 text-section-muted" />

          {/* Current Page */}
          <span className="px-2 py-1 text-section-text font-medium truncate max-w-[55vw] sm:max-w-none">
            Product Details
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumb;
